import Vue from 'vue'
import { toCurrencyFormat } from './../js/custom'

export default Vue.filter('currency', function (value, decimal = 2) {
    let result = toCurrencyFormat({ value, decimal })
    return result
});
